export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getAll: state => state.items,
    getAllForSelect: state => {
      var items = []
      state.items.forEach(item => {
        if(!item.parent_equipment_group_id){
          items.push({
            value: item.id,
            text: item.name
          })
          if(item.equipment_groups && item.equipment_groups.length){
            item.equipment_groups.forEach(subitem => {
              items.push({
                value: subitem.id,
                text: '-- '+subitem.name
              })
            })
          }
        }
      })
      return items
    },
    getItem: state => id => state.items.find(item => item.id == id)
  },
  actions: {

    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'equipmentgroup',
        api_data_path: 'equipmentGroups',
        namespace: 'equipment_group'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/equipment_group.js